import { debounce } from 'debounce'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import FilterBar from '@modules/admin/shared/FiltersBar'
import AccessControl from '@modules/auth/AccessControl'
import { selectSelfCompanies } from '@modules/auth/auth.Dux'
import CustomPagination from '@modules/tableComponents/Pagination'
import InputField from '@modules/formFields/InputField'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectField from '@modules/formFields/SelectField'
import React, { Component } from 'react'
import { withTranslation, Trans } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Consultations from '@services/Consultations'
import Processing from '../../core/components/Loading'
import '../shared/filters.scss'
import CustomerTable from './Customer.Index.Table'
import Alert from '../../../adminv2/common/Alert'
import { Link } from 'react-router-dom'

class CustomerIndexContainer extends Component {
  state = {
    customers: null,
    page: null,
    pageSize: 50,
    total: 0,
    isFetching: false,
    search: '',
    showFilters: false,
    companyFilter: this.props.selfCompanies,
    nameFilter: '',
    tokenFilter: '',
    emailFilter: '',
    phoneFilter: '',
    nifFilter: '',
    accessFilter: undefined,
    typeFilter: undefined,
  }

  onTypeSearch = (search) => {
    return this.setState({ search, page: 1 }, this.debouncedFetch)
  }

  fetchCustomers = () => {
    this.setState({ isFetching: true })

    const { page, pageSize } = this.state
    const filters = {
      search: this.state.search,
      nameFilter: this.state.nameFilter || undefined,
      phoneFilter: this.state.phoneFilter || undefined,
      emailFilter: this.state.emailFilter || undefined,
      nifFilter: this.state.nifFilter || undefined,
      tokenFilter: this.state.tokenFilter || undefined,
      accessFilter: this.state.accessFilter ? this.state.accessFilter.id : undefined,
      vipFilter: this.state.typeFilter && this.state.typeFilter.id === 1 ? this.state.typeFilter.id : undefined,
      companyFilter: this.state.companyFilter.map((co) => co.api_key),
    }

    return Consultations.customer
      .index({ page, pageSize, ...filters })
      .then((response) => {
        const { data, meta } = response
        return this.setState({
          customers: data,
          page: meta.current_page,
          lastPage: meta.last_page,
          isFetching: false,
          total: meta.total,
        })
      })
      .catch((err) => {
        window.alert(JSON.stringify(err.message, null, 2))
      })
  }
  debouncedFetch = debounce(this.fetchCustomers, 350, false)

  handleChangePage = (page) => {
    return this.setState({ page }, this.fetchCustomers)
  }

  UNSAFE_componentWillMount() {
    this.fetchCustomers()
  }

  render() {
    const {
      isFetching,
      customers,
      nameFilter,
      companyFilter,
      tokenFilter,
      emailFilter,
      phoneFilter,
      nifFilter,
      accessFilter,
      typeFilter,
      total,
    } = this.state

    const { t } = this.props

    return (
      <div>
        <DashboardHeader title={<Trans>Usuarios</Trans>} total={total}>
          <Link className="btn btn-primary" to={`/customers/create`}>
            <Trans>Crear</Trans>
          </Link>
        </DashboardHeader>

        <FilterBar onChange={this.onTypeSearch} value={this.state.search}>
          <InputField
            placeholder={t('Nombre')}
            input={{
              value: nameFilter,
              onChange: (e) => this.setState({ nameFilter: e.target.value, page: 1 }),
            }}
          />
          <AccessControl requiredRole="super-admin">
            <SelectCompanyField
              placeholder={t('Compañías')}
              multi
              input={{
                value: companyFilter,
                onChange: (companies) => this.setState({ companyFilter: companies, page: 1 }),
              }}
            />
          </AccessControl>
          <InputField
            placeholder={t('Token')}
            input={{
              value: tokenFilter,
              onChange: (e) => this.setState({ tokenFilter: e.target.value, page: 1 }),
            }}
          />
          <InputField
            placeholder={t('Email')}
            input={{
              value: emailFilter,
              onChange: (e) => this.setState({ emailFilter: e.target.value, page: 1 }),
            }}
          />
          <InputField
            placeholder={t('Teléfono')}
            input={{
              value: phoneFilter,
              onChange: (e) => this.setState({ phoneFilter: e.target.value, page: 1 }),
            }}
          />
          <InputField
            placeholder={t('DNI')}
            input={{
              value: nifFilter,
              onChange: (e) => this.setState({ nifFilter: e.target.value, page: 1 }),
            }}
          />
          <SelectField
            placeholder={t('Acceso')}
            input={{
              value: accessFilter,
              onChange: (e) => this.setState({ accessFilter: e, page: 1 }),
            }}
            options={[
              { id: 1, name: t('Han accedido') },
              { id: 0, name: t('No han accedido') },
            ]}
          />
          <SelectField
            placeholder={t('userType')}
            input={{
              value: typeFilter,
              onChange: (e) => this.setState({ typeFilter: e, page: 1 }),
            }}
            options={[
              { id: 0, name: t('Todos') },
              { id: 1, name: 'VIP' },
            ]}
          />
        </FilterBar>

        <Processing isFetching={isFetching} />
        <Alert timeOut={3000} />
        {customers && <CustomerTable customers={customers} />}

        <CustomPagination
          onClickItem={this.handleChangePage}
          activePage={this.state.page}
          totalPages={this.state.lastPage}
          maxButtons={7}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  selfCompanies: selectSelfCompanies(state),
})
export default compose(withTranslation(), connect(mapStateToProps))(CustomerIndexContainer)
